/* Mr Pixel — keeps the Afterpay instalment line on the selected variant's price.

   The Afterpay app block watches network requests for `section_id=<id>&variant=<id>`
   and reads the new price from that. Spotlight 15 fetches with `option_values=`
   instead, so the app never matched and the line stayed on the first variant's
   price (PS1 console, 2026-09-28: $179.99 selected, instalments of $40.00).
   This listens for the theme's own variant event, as mp-points-badge.js does,
   and sets data-amount, which <square-placement> observes and re-renders from. */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data && event.data.variant;
    const section = document.getElementById(`shopify-section-${event.data.sectionId}`);
    if (!variant || !section) return;
    section.querySelectorAll('square-placement').forEach((placement) => {
      placement.setAttribute('data-amount', (variant.price / 100).toFixed(2));
    });
  });
}
